// ============================================================================
// Where code work belongs. Coding agents, Repositories and "Hand to agent" are
// DevOS furniture: a Life project (Move house) or a house task (Hoover the
// stairs) never offers them. They show for a project that names repos, or
// anything in a dev workspace (the DevOS suite or the dev pack).
// ============================================================================
import { useCurrentWorkspace, useWorkspaceBySlug } from '@/db/hooks'
import { useFactoryEnabled } from '@/kinds/agentrun/components'
import { suiteOf } from '@/suites'

/** Pure: a workspace record (or none) and the project's repos. */
export const codeWorkHere = (
  w: { spec: { suite?: string; packs?: string[] } } | undefined,
  repos: readonly string[] | undefined,
): boolean => (repos?.length ?? 0) > 0 || (!!w && suiteOf(w).id === 'devos')

/** The workspace by slug, else the one the device is in (a new project has no label yet). */
const useWorkspace = (ws: string | undefined) => {
  const bySlug = useWorkspaceBySlug()
  const current = useCurrentWorkspace()
  return ws ? bySlug.get(ws) : current
}

/** Whether a project or task in `ws` (with the project's `repos`) is code work, factory or not. */
export const useCodeWorkHere = (ws: string | undefined, repos?: readonly string[]): boolean =>
  codeWorkHere(useWorkspace(ws), repos)

/** Whether to offer coding agents here: the factory is on and this is code work. */
export const useAgentsHere = (ws: string | undefined, repos?: readonly string[]): boolean => {
  const factory = useFactoryEnabled()
  const here = useCodeWorkHere(ws, repos)
  return factory && here
}
